// extracted by mini-css-extract-plugin
module.exports = {"container":"bH47j","button":"_3vgGp","icon":"_3Kh5M","text":"eLXtB","title":"OcJtj","info":"_3GmbW"};